import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  text: {
    marginRight: theme.spacing(2),
    color: theme.palette.colors.gray,
  },
  active: {
    color: theme.palette.colors.black,
  },
  icon: {
    width: 20,
    height: 20,
    fill: theme.palette.colors.teal,
  },
  loader: {
    color: theme.palette.colors.teal,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/BidRequestCreatingProgress/useStyles.js